import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PatientService } from '@ispm-client/modules/patient/services/patient.service';

const DEFAULT_SIZE_LIMIT = 5;

@Component({
  selector: 'gen-search-result-table',
  templateUrl: './search-result-table.component.html',
  styleUrls: ['./search-result-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchResultTableComponent<T> implements OnInit {
  @Input()
  columnDefs: {
    title: string;
    mapFn?: (_: T) => string;
  }[];

  @Input()
  rowData: Array<T>;

  @Input()
  title: string;

  @Input()
  limit: number = DEFAULT_SIZE_LIMIT;

  @Output()
  rowSelected: EventEmitter<T> = new EventEmitter<T>();

  total: number = 0;

  constructor(private patientService: PatientService) { }

  ngOnInit() {
    this.total = this.rowData.length;
  }

  getRowDisplayByMap(row: T, mapFn?: (_: T) => string): string {
    return mapFn ? mapFn(row) : row.toString();
  }

  onRowClicked(row: T) {
    this.rowSelected.emit(row);
  }

  getRowData(rowData, index) {
    return rowData.slice(0, this.limit)[0];
  }

  showAll() {
    this.limit = this.total;
  }

  getFixedWidth(collection) {
    return 100 / collection.length;
  }
  displayTooltipValues(row: any) {          
    let identifiertoolTip = this.patientService.getIdentifierToolTip(row.mergedIdentifiers)
    return identifiertoolTip;
  }
}
